import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {compose} from 'redux';

import {gql, graphql} from 'react-apollo';
import ClientAnalyticsSetupForm from '@modules/client/forms/ClientAnalyticsSetupForm';
import {getLink} from '@appComponents/Link';
import * as clientAnalyticsSetupGraphQl from '@graphql/clients/clientAnalyticsSetup';

export class ClientAnalyticsSetupsIndex extends React.Component {
    static propTypes = {
        client: PropTypes.object,
        clientId: PropTypes.number.isRequired,
        DataClientAnalyticsSetups: PropTypes.object.isRequired,
        DeleteWhitelistedIp: PropTypes.func,
        match: PropTypes.object.isRequired,
        Modal: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.state = {
            clientAnalyticsSetups: undefined,
        };
    }

    static getDerivedStateFromProps(nextProps) {
        const {DataClientAnalyticsSetups: {clientAnalyticsSetups}} = nextProps;

        if (clientAnalyticsSetups) {
            return {
                clientAnalyticsSetups: clientAnalyticsSetups[0],
            };
        }

        return null;
    }

    resetIndexUrl = () => {
        window.history.pushState({}, '', getLink('clients.clientAnalyticsSetups.index', {id: this.props.clientId}));
    };

    render() {
        return (
            <ClientAnalyticsSetupForm
                clientId={this.props.clientId}
                clientName={this.props.client ? this.props.client.name : ''}
                formData={{clientAnalyticsSetup: this.state.clientAnalyticsSetups}}
                loading={this.props.DataClientAnalyticsSetups.loading}
                resetIndexUrl={this.resetIndexUrl}
            />
        );
    }
}

const ClientAnalyticsSetupsQuery = gql(clientAnalyticsSetupGraphQl.clientAnalyticsSetupDataQuery);

const ClientAnalyticsSetupsWithGraphQL = compose(
    graphql(ClientAnalyticsSetupsQuery, {
        options: (props) => {
            return {
                fetchPolicy: 'network-only',
                notifyOnNetworkStatusChange: true,
                variables: {
                    clientId: props.clientId,
                },
            };
        },
        name: 'DataClientAnalyticsSetups',
    })
)(ClientAnalyticsSetupsIndex);

const mapStateToProps = (state) => {
    return {
        client: state.app.entities.client,
    };
};

export default withRouter(connect(mapStateToProps)(ClientAnalyticsSetupsWithGraphQL));
